/** Gleiche Elemente in beiden Sets? Für das `oldValue`-Muster von Set-Computeds – `a` fehlt beim ersten Lauf. */
export function sameMembers<T>(a: Set<T> | undefined, b: Set<T>): a is Set<T> {
  return !!a && a.size === b.size && [...b].every((item) => a.has(item))
}
